/* eslint-disable @typescript-eslint/no-this-alias */
/**
 * Copyright (C) 2019 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */
import { NativeEventSource, EventSourcePolyfill } from 'event-source-polyfill';

global.EventSource = NativeEventSource || EventSourcePolyfill;

// https://developer.mozilla.org/en-US/docs/Web/API/Element/closest#Polyfill
const pollyfillEllementClosest = () => {
  if (!Element.prototype.matches) {
    Element.prototype.matches = Element.prototype['msMatchesSelector'] || Element.prototype['webkitMatchesSelector'];
  }

  if (!Element.prototype.closest) {
    // @ts-ignore
    Element.prototype.closest = function(s) {
      let el = this;

      do {
        // @ts-ignore
        if (el.matches(s)) return el;
        // @ts-ignore
        el = el.parentElement || el.parentNode;
      } while (el !== null && el.nodeType === 1);
      return null;
    };
  }
};
pollyfillEllementClosest();

//https://developer.mozilla.org/en-US/docs/Web/API/NodeList/forEach
if (window.NodeList && !NodeList.prototype.forEach) {
  NodeList.prototype.forEach = function(callback, thisArg) {
    thisArg = thisArg || window;
    for (let i = 0; i < this.length; i += 1) {
      callback.call(thisArg, this[i], i, this);
    }
  };
}
